import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import erorrHandler from '../../services/web/erorrHandler';
import agent from '../../services/web/agent';

class RolesStore {

    @setter @observable roles;
    @setter @observable editRole;
    @setter @observable duplicatedRole;


    // model
    @setter @observable name = '';
    @setter @observable description = '';
    @setter @observable permissionIds = [];

    @setter @observable getRoleInProgress;
    @setter @observable createRoleInProgress;
    @setter @observable updateRoleInProgress;
    @setter @observable deletingRoleInProgress;

    @setter @observable getRoleErrorMessage;
    @setter @observable createRoleErrorMessage;
    @setter @observable updateRoleErrorMessage;
    @setter @observable deleteRoleErrorMessage;

    @action setPermissionId(permissionId) {

        const index = this.permissionIds.indexOf(permissionId);

        if (index == -1) {
            this.permissionIds.push(permissionId);
        }
    }

    @action removePermissionId(permissionId) {

        const index = this.permissionIds.indexOf(permissionId);

        if (index > -1) {
            this.permissionIds.splice(index, 1);
        }
    }

    @action getAllRoles() {

        return agent.Roles.getAllRoles()
            .then(action((roles) => {
                
                this.roles = roles;
                
            }));
    }

    @action getRole(id) {

        if(id < 1)
        {
            const _this = this;
            return new Promise(function(resolve, reject) {
                resolve(_this.editRole);
            });
        }
        else{
            return agent.Roles.getRole(id)
            .then(action(role => {
                
                this.editRole = role;
                return role;
            }));
        }
    }

    @action createRole(role) {

        this.updateRoleInProgress = true;

        return agent.Roles.createRole(role)
            .then(action(_ => {
                
            }))
            .catch(action(err => {

                this.updateRoleErrorMessage = erorrHandler.getErrorMessage(err);

                throw err;
            }))
            .finally(action(_ => this.updateRoleInProgress = false));
    }

    @action updateRole(id, role) {

        this.updateRoleInProgress = true;

        return agent.Roles.updateRole(id, role)
            .then(action(_ => {
                
            }))
            .catch(action(err => {

                this.updateRoleErrorMessage = erorrHandler.getErrorMessage(err);

                throw err;
            }))
            .finally(action(_ => this.updateRoleInProgress = false));
    }

    @action deleteRole(id) {

        this.deletingRoleInProgress = true;

        return agent.Roles.deleteRole(id)
            .then(action(_ => {
                
            }))
            .catch(action(err => {

                this.deleteRoleErrorMessage = erorrHandler.getErrorMessage(err);

                throw err;
            }))
            .finally(action(_ => this.deletingRoleInProgress = false));
    }

    @action resetForm = _ => {

        this.name = '';
        this.description = '';
        this.permissionIds = [];
    }

    @action getUserRoleNames(roleIds) {
        let roleNames = [];
        let roleIdArray = (String(roleIds).split(',')).filter(n => n);
        for (let i = 0; i < roleIdArray.length; i++) {
            let roleResult = this.roles.filter(t => t.id == roleIdArray[i]);
            if (roleResult != null) {
                roleNames.push(roleResult[0].name);
            }
        }
        return roleNames;
    }

    getRoleIdByName = async (role) => {
        if (this.roles === undefined){
            await this.getAllRoles();
        }

        return this.roles.filter(r => r.name === role)[0].id;
    }
}

export default new RolesStore();


// WEBPACK FOOTER //
// ./src/stores/roles/index.js